import { TenantEntity } from '../TenantEntity'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getAirPortByCode } from '@/api/airport'

export class AirPort extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get serialNumber() {
    return this._data.serialNumber
  }
  set serialNumber(serialNumber) {
    this._data.serialNumber = serialNumber
  }
  get interchangeCode() {
    return this._data.interchangeCode
  }
  set interchangeCode(interchangeCode) {
    this._data.interchangeCode = interchangeCode
  }
  get isoCode() {
    return this._data.isoCode
  }
  set isoCode(isoCode) {
    this._data.isoCode = isoCode
  }
  get code() {
    return this._data.code
  }
  set code(code) {
    this._data.code = code
  }
  get englishName() {
    return this._data.englishName
  }
  set englishName(englishName) {
    this._data.englishName = englishName
  }
  get chineseName() {
    return this._data.chineseName
  }
  set chineseName(chineseName) {
    this._data.chineseName = chineseName
  }
  get countryCode() {
    return this._data.countryCode
  }
  set countryCode(countryCode) {
    this._data.countryCode = countryCode
  }
  get region() {
    return this._data.region
  }
  set region(region) {
    this._data.region = region
  }

  get countryCnName() {
    return this._data.countryCnName
  }
  set countryCnName(countryCnName) {
    this._data.countryCnName = countryCnName
  }
  get countryEnName() {
    return this._data.countryEnName
  }
  set countryEnName(countryEnName) {
    this._data.countryEnName = countryEnName
  }
  get regionCnName() {
    return this._data.regionCnName
  }
  set regionCnName(regionCnName) {
    this._data.regionCnName = regionCnName
  }
  get regionEnName() {
    return this._data.regionEnName
  }
  set regionEnName(regionEnName) {
    this._data.regionEnName = regionEnName
  }

  static async getAirportByCode(code) {
    if (!code) return null
    let airport = getObjectByCache(basicCacheKeys.basic_data_Airport, 'code', code)
    if (!airport) {
      airport = await getAirPortByCode(code).then(res => res.data)
    }
    return airport
  }
}
